// Le dessin : couleurs des tuiles, tuiles, sprites, cycle jour/nuit.
// Extrait de KubeWorld.jsx au lot A (2026-09-08) : le code n'a pas ete modifie.
import { T } from './base.js';
import { dessinerCase } from './tuiles.js';
import { dessinerTuile } from './atlas.js';

// ═══ DRAWING ═══
const TC={
  '.':'#3a5a3a',',':'#5a8c4f','=':'#c4a462','+':'#d4b472',' ':'#4a7c3f',
  // Hub: metal/tech
  'M':'#3a4050','C':'#2a3545','c':'#3f4a63','r':'#6a6a5a',
  // Pods: nature
  'g':'#3a6a2f','p':'#8a7a5a',
  'V':'#1f3d1a', // haie dense : coloree, mais absente de WK donc infranchissable
  // Sols par zone : chaque lieu a le sien, sinon tout se ressemble
  'm':'#2f3542','e':'#6b5a45','n':'#16233f','a':'#2e2440',

  // Workloads: fortress
  'I':'#5a4a40','J':'#6a5a4a','G':'#4a4a3a',
  // Network: cyber
  'N':'#1a2a4a','b':'#5a5a4a',
  '~':'#2a5d9e',
  // Sanctum: arcane
  'P':'#3a2a4a','K':'#7a3aaa','Q':'#4a2a6a',
  // Lava for boss arena
  'H':'#4a1a0a',
  // Shared
  'B':'#8b7355','F':'#3a3a4a','o':'#5a7c4f','S':'#7b5533',
  '#':'#5b5b6b','W':'#6b6b7b','*':'#5a8c4f','L':'#5a8c4f','D':'#5a8c4f','T':'#5a8c4f',
};
// ═══ PALETTES PAR ZONE ═══
// ⭐ Une tuile ne connait plus sa couleur : elle connait sa MATIERE et sa ZONE.
// Avant, la moitie des decors repeignaient leur fond en vert gazon, en dur : le
// moteur avait ete ecrit pour un seul decor. Des que chaque zone a eu son sol, on
// voyait des cables en herbe dans une salle de controle et des cristaux violets
// poses sur une prairie.
const PAL={
  hub:      {sol:'#2b303c',solAlt:'#313846',mur:'#4b5568',murTop:'#6b7890',ombre:'#171a21',acc:'#54a0ff',acc2:'#39ff14',dalle:'#3f4a5e'},
  pods:     {sol:'#4a7c3f',solAlt:'#50843f',mur:'#2b4d23',murTop:'#3d6b31',ombre:'#16280f',acc:'#c9a227',acc2:'#8a7a5a',dalle:'#c4a462'},
  workloads:{sol:'#6b5a45',solAlt:'#72604a',mur:'#3b322a',murTop:'#574a3c',ombre:'#1d1811',acc:'#ff8c00',acc2:'#a8946f',dalle:'#8a7358'},
  network:  {sol:'#243b5c',solAlt:'#2a405f',mur:'#0f1c33',murTop:'#2d5c9e',ombre:'#080e1a',acc:'#54a0ff',acc2:'#39ff14',dalle:'#33507a'},
  sanctum:  {sol:'#2e2440',solAlt:'#342949',mur:'#3f2e5c',murTop:'#5b4383',ombre:'#140e1f',acc:'#a55eea',acc2:'#e0b0ff',dalle:'#4a3a6a'},
};

// Ce qui fait bloc. Tout le reste se traverse ou se pose sur le sol.
const MURS=new Set('MINPVW#');
const estMur=(c)=>c===undefined||MURS.has(c);

// Tirage stable par case : deux voisines ne se ressemblent pas, et rien ne scintille
// d'une image a l'autre. C'est ce qui remplace le damier, qui se lisait comme une grille.
const bruit=(x,y)=>{let h=(x*73856093)^(y*19349663);h=(h^(h>>>13))*1274126177;return((h^(h>>>16))>>>0)%1000;};

// Le dessin d'une case est delegue a jeu/tuiles.js, qui applique les regles de
// docs/REGLES.md. Cette fonction ne fait plus que passer les voisines.
function dTile(ctx,tx,ty,ch,tick,nA,zn,vois){
  dessinerCase(ctx,tx*T,ty*T,ch,vois,zn,tick,nA,T);
}

// ═══ PERSONNAGES ═══
// Modeles pris dans la planche Kenney. Chaque PNJ garde le sien : deux personnes
// differentes ne doivent pas se ressembler (regle R9).
// Modeles choisis pour se distinguer les uns des autres : sur les douze disponibles,
// six portent la meme chemise orange et se confondaient sur la carte (R9).
const MODELES=[[1,5],[0,6],[1,6],[0,7],[0,9],[0,10],[0,11],[1,11],[1,9],[0,5]];
const modele=(cle)=>{let h=0;for(let i=0;i<cle.length;i++)h=(h*31+cle.charCodeAt(i))>>>0;return MODELES[h%MODELES.length];};

// Marqueur au-dessus d'un PNJ : on doit savoir quoi en attendre SANS lui parler (R9).
// Une bulle, pas un pave : le marqueur doit se remarquer sans ecraser le personnage
// qu'il designe (regle R8). Sa pointe touche la tete, sa couleur dit de quoi il s'agit.
function dMarqueur(ctx,x,y,signe,couleur){
  const cx=x+T/2,l=15,h=14,bx=cx-l/2,ty=y-24;
  ctx.save();
  ctx.beginPath();ctx.roundRect(bx,ty,l,h,4);ctx.moveTo(cx-3,ty+h-1);ctx.lineTo(cx,ty+h+4);ctx.lineTo(cx+3,ty+h-1);
  ctx.fillStyle='rgba(12,15,22,0.72)';ctx.fill();
  ctx.beginPath();ctx.roundRect(bx+0.5,ty+0.5,l-1,h-1,4);
  ctx.strokeStyle=couleur;ctx.lineWidth=1;ctx.stroke();
  ctx.fillStyle=couleur;ctx.font='bold 11px monospace';ctx.textAlign='center';ctx.textBaseline='middle';
  ctx.fillText(signe,cx,ty+h/2+1);ctx.textBaseline='alphabetic';
  ctx.restore();
}

function dSprite(ctx,px,py,type,d,tick){
  const x=px*T,y=py*T;
  const ombre=(l,h2,dy2)=>{ctx.fillStyle='rgba(0,0,0,0.32)';ctx.beginPath();ctx.ellipse(x+T/2,y+T-(dy2||4),l,h2,0,0,Math.PI*2);ctx.fill();};

  if(type==='player'){
    const b=d.walk?Math.sin(tick*0.3)*1.5:0;
    ctx.fillStyle='rgba(120,200,255,0.20)';ctx.beginPath();ctx.ellipse(x+T/2,y+T-3,15,6,0,0,Math.PI*2);ctx.fill();
    ombre(11,4);
    ctx.save();ctx.shadowColor='#9fd8ff';ctx.shadowBlur=6;
    dessinerTuile(ctx,'perso',0,6,x,y-8+b,T);
    ctx.restore();
    const f=Math.sin(tick*0.08)*1.5;
    ctx.fillStyle='#9fd8ff';
    ctx.beginPath();ctx.moveTo(x+T/2,y-13+f);ctx.lineTo(x+T/2-5,y-20+f);ctx.lineTo(x+T/2+5,y-20+f);ctx.closePath();ctx.fill();
  }
  else if(type==='npc'){
    const bob=Math.sin(tick*0.04+px)*1.2;
    if(d.boss){const p=Math.sin(tick*0.1)*0.3+0.7;ctx.fillStyle=`rgba(255,50,50,${p*0.22})`;ctx.beginPath();ctx.arc(x+T/2,y+T/2,18,0,Math.PI*2);ctx.fill();}
    ombre(11,4);
    const m=d.boss?[1,9]:modele(d.name||'');
    dessinerTuile(ctx,'perso',m[0],m[1],x,y-6+bob,T);
    if(d.marqueur)dMarqueur(ctx,x,y+bob,d.marqueur.signe,d.marqueur.couleur);
  }
  else if(type==='enemy'){
    // Une creature, pas un carre de couleur avec un emoji pose dessus (R9).
    // La teinte de l'incident se met en halo autour d'elle plutot qu'en aplat.
    const bob=Math.sin(tick*0.08+d.seed)*2;
    ombre(9,3);
    const p2=Math.sin(tick*0.09+d.seed)*0.25+0.55;
    ctx.fillStyle=(d.color||'#bb33ff');ctx.globalAlpha=p2*0.35;
    ctx.beginPath();ctx.arc(x+T/2,y+T/2+bob,T*0.55,0,Math.PI*2);ctx.fill();ctx.globalAlpha=1;
    dessinerTuile(ctx,'perso',0,3,x,y-4+bob,T);
    dMarqueur(ctx,x,y+bob,'!','#ff8c42');
  }
  else if(type==='companion'){
    const f=Math.sin(tick*0.06)*3;
    ctx.fillStyle='rgba(0,0,0,0.20)';ctx.beginPath();ctx.ellipse(x+T/2,y+T-4,7,3,0,0,Math.PI*2);ctx.fill();
    ctx.fillStyle='#54a0ff';ctx.fillRect(x+10,y+8+f,12,12);
    ctx.fillStyle='#fff';ctx.fillRect(x+13,y+12+f,3,3);ctx.fillRect(x+18,y+12+f,3,3);
  }
  else if(type==='chest'){
    ombre(10,4);
    dessinerTuile(ctx,'monde',38,9,x,y-4,T);
    const p=Math.sin(tick*0.1)*0.4+0.6;
    ctx.fillStyle=`rgba(255,215,0,${p*0.35})`;ctx.beginPath();ctx.arc(x+T/2,y+T/2-4,T*0.5,0,Math.PI*2);ctx.fill();
  }
  else if(type==='portal'){
    const p=Math.sin(tick*0.08)*0.3+0.7;
    ctx.fillStyle=`rgba(140,50,255,${p*0.85})`;ctx.fillRect(x+4,y+4,T-8,T-8);
    ctx.fillStyle=`rgba(210,170,255,${p*0.6})`;ctx.fillRect(x+9,y+9,T-18,T-18);
    ctx.fillStyle=`rgba(140,50,255,${p*0.20})`;ctx.beginPath();ctx.arc(x+T/2,y+T/2,T*0.75,0,Math.PI*2);ctx.fill();
  }
  else if(type==='house'){
    // Un batiment, pas une icone posee au sol (R6, R9).
    // ⚠️ Il occupe 3x3 cases : si la place n'est pas libre, il se plaque sur les murs de
    // la piece qui l'entoure. Dans ce cas on ne pose qu'une porte, dans son encadrement.
    if(d&&d.placeLibre){
      ctx.fillStyle='rgba(0,0,0,0.28)';ctx.fillRect(x-T+5,y-2*T+9,3*T-10,2*T+3);
      for(let i=-1;i<=1;i++)for(let j=-2;j<=0;j++)dessinerTuile(ctx,'monde',15,14,x+i*T,y+j*T,T);
      for(let i=-1;i<=1;i++)dessinerTuile(ctx,'monde',24+i,22,x+i*T,y-3*T+6,T);
      dessinerTuile(ctx,'monde',41,7,x,y,T);
      dessinerTuile(ctx,'monde',40,4,x-T,y-T,T);dessinerTuile(ctx,'monde',40,4,x+T,y-T,T);
    }else{
      ctx.fillStyle='rgba(0,0,0,0.30)';ctx.fillRect(x+2,y+3,T-4,T-3);
      dessinerTuile(ctx,'monde',15,14,x,y,T);
      dessinerTuile(ctx,'monde',41,7,x,y,T);
      ctx.fillStyle='rgba(255,214,102,0.30)';ctx.fillRect(x+4,y+4,T-8,T-8);
    }
    if(d&&d.marqueur)dMarqueur(ctx,x,y,d.marqueur.signe,d.marqueur.couleur);
  }
}

// Nuit courte et legere : elle doit poser une ambiance, jamais empecher de lire l'ecran.
// Avant : 20h-06h a pleine intensite, soit dix heures sur vingt-quatre ou le jeu etait sombre.
const getNight=t=>{if(t>=300&&t<390)return 1-(t-300)/90;if(t>=390&&t<1260)return 0;if(t>=1260&&t<1350)return(t-1260)/90;return 1;};
const clock=t=>`${String(Math.floor(t/60)%24).padStart(2,'0')}:${String(t%60).padStart(2,'0')}`;

export { TC, PAL, dTile, dSprite, dMarqueur, getNight, clock };
